const aboutImage = require("../images/geotechnical-survey.jpeg");
const localTerrain = require("../images/geotechnical-survey6.jpeg");
const badge = require("../images/badge_180x55.jpg");

export { aboutImage, localTerrain, badge };
